export default __webpack_public_path__ + "static/media/pulse.2b635263.svg";